import React from "react";
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from "date-fns/locale";

function MyDatePicker(props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <DatePicker
        type="date"
        disabled={props.disabled}
        value={props.value}
        maxDate={props.toDate}
        minDate={props.fromDate}
        inputFormat="dd/MM/yyyy"
        views={["day", "month", "year"]}
        onChange={(event) => {
          props.action(event);
        }}
        renderInput={(params) => (
          <TextField style={props.style} {...params} />
        )}
      />
    </LocalizationProvider>
  );
}
export default MyDatePicker;